<template>
  <config-item :label="''">
    <div class="layout-source">
      <div class="layout-source__header">
        <span class="layout-source__title">列表布局选择</span>
        <label
          class="layout-source__mode-item"
          :class="{ active: layoutMode === 'list' }"
        >
          <input
            type="radio"
            name="layoutMode"
            value="list"
            :checked="layoutMode === 'list'"
            @change="switchMode('list')"
          />
          列表式布局
        </label>
        <label
          class="layout-source__mode-item"
          :class="{ active: layoutMode === 'waterfall' }"
        >
          <input
            type="radio"
            name="layoutMode"
            value="waterfall"
            :checked="layoutMode === 'waterfall'"
            @change="switchMode('waterfall')"
          />
          瀑布流布局
        </label>
      </div>

      <div class="layout-source__body">
        <div
          v-for="item in visibleItems"
          :key="item.id"
          class="layout-item"
          :class="{ active: currentLayoutType === item.value }"
          @click="selectLayout(item.value)"
        >
          <span v-if="currentLayoutType === item.value" class="layout-item__check">✓</span>
          <img class="layout-item__image" :src="item.image" :alt="item.label" />
          <span class="layout-item__label">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </config-item>
</template>

<script>
import schemaMixin from '@/mixin/schemaMixin';

export default {
  name: 'SchemaLayoutSource',
  mixins: [schemaMixin],
  inject: {
    control: { default: null },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      layoutMode: 'list',
    };
  },
  computed: {
    currentLayoutType() {
      return (this.mValue && this.mValue.layoutType) || 'list-top-bottom';
    },
    visibleItems() {
      return (this.data || []).filter((item) => {
        const group = item.group || 'list';
        return group === this.layoutMode;
      });
    },
  },
  created() {
    const layoutType =
      (this.mValue && this.mValue.layoutType) || 'list-top-bottom';
    this.layoutMode = this.resolveMode(layoutType);
    this.applyLayoutType(layoutType, {
      silent: !!(this.mValue && this.mValue.layoutType),
    });
  },
  methods: {
    resolveMode(layoutType) {
      const type = String(layoutType || '');
      if (
        type.startsWith('waterfall') ||
        type === 'card-list' ||
        type === 'waterfall'
      ) {
        return 'waterfall';
      }
      return 'list';
    },
    switchMode(mode) {
      this.layoutMode = mode;
      const items = (this.data || []).filter((item) => (item.group || 'list') === mode);
      if (!items.length) return;
      const stillValid = items.some((item) => item.value === this.currentLayoutType);
      if (!stillValid) {
        this.applyLayoutType(items[0].value);
      }
    },
    applyLayoutType(layoutType, options = {}) {
      const next = { layoutType };
      this.mValue = next;
      if (!options.silent) {
        this.$emit('input', next);
        this.$emit('change', next);
      }

      const widget = this.control && this.control.curWidget;
      if (!widget) return;
      if (!widget.attrs) this.$set(widget, 'attrs', {});
      this.$set(widget.attrs, 'layoutSource', next);
      this.layoutMode = this.resolveMode(layoutType);
    },
    selectLayout(layoutType) {
      this.applyLayoutType(layoutType);
    },
  },
};
</script>

<style scoped lang="scss">
.layout-source {
  &__header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }

  &__title {
    font-size: 13px;
    color: #323233;
    margin-right: 16px;
    line-height: 22px;
  }

  &__mode-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-right: 16px;
    font-size: 13px;
    color: #323233;
    cursor: pointer;
    line-height: 22px;

    &.active {
      color: #155bd4;
    }

    input {
      margin: 0;
      cursor: pointer;
      accent-color: #155bd4;
    }
  }

  &__body {
    width: 340px;
    overflow-x: auto;
    display: flex;
    gap: 8px;
  }
}

.layout-item {
  position: relative;
  flex: 1;
  min-width: 0;
  padding: 10px 5px 8px;
  border: 1px solid #ebedf0;
  border-radius: 6px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: #155bd4;
  }

  &.active {
    border-color: #155bd4;
    box-shadow: 0 0 0 1px #155bd4 inset;
  }

  &__check {
    position: absolute;
    top: 4px;
    right: 6px;
    font-size: 12px;
    color: #155bd4;
    font-weight: 700;
    line-height: 1;
  }

  &__image {
    display: block;
    width: 100%;
    max-width: 70px;
    height: 50px;
    object-fit: contain;
    margin: 0 auto;
  }

  &__label {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: #646566;
  }

  &.active &__label {
    color: #155bd4;
  }
}
</style>
